import React from 'react';
import styled from '@emotion/styled';
import IconCheck from '../../icons/IconCheck';

const Overlay = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  min-height: 100vh;
  background: #f5f5f7;
`;

const Card = styled.div`
  background: #111112;
  border-radius: 32px;
  box-shadow: 0 4px 32px rgba(0,0,0,0.10);
  padding: 56px 40px 40px 40px;
  max-width: 480px;
  width: 100%;
  display: flex;
  flex-direction: column;
  align-items: center;
`;

const CheckIconWrapper = styled.div`
  margin-bottom: 32px;
`;

const Title = styled.div`
  color: #fff;
  font-family: 'Clash Grotesk', sans-serif;
  font-size: 1.4rem;
  font-weight: 600;
  text-align: center;
  margin-bottom: 12px;
`;

const AccentMessage = styled.div`
  color: #F43F60;
  font-family: 'Clash Grotesk', sans-serif;
  font-size: 1.15rem;
  font-weight: 600;
  text-align: center;
  margin-bottom: 36px;
`;

const Button = styled.button`
  width: 100%;
  background: #F43F60;
  color: #fff;
  font-family: 'Clash Grotesk', sans-serif;
  font-size: 1.15rem;
  font-weight: 600;
  border: none;
  border-radius: 18px;
  padding: 18px 0;
  margin-top: 12px;
  cursor: pointer;
  transition: background 0.2s;
  &:hover {
    background: #e03a56;
  }
`;

const InfoMessage = ({
    title = 'Your offer has been submitted!',
    accentMessage = 'We will contact you soon!',
    buttonText = 'Okay',
    onButtonClick,
    showOverlay = false,
}) => {
    const content = (
        <Card>
            <CheckIconWrapper>
                <IconCheck size={56} color="#fff" />
            </CheckIconWrapper>
            <Title>{title}</Title>
            <AccentMessage>{accentMessage}</AccentMessage>
            <Button onClick={onButtonClick}>{buttonText}</Button>
        </Card>
    );
    if (showOverlay) {
        return <Overlay>{content}</Overlay>;
    }
    return content;
};

export default InfoMessage; 